import { render, staticRenderFns } from "./SwitchFund.vue?vue&type=template&id=40b8baa1"
import script from "./SwitchFund.vue?vue&type=script&lang=js"
export * from "./SwitchFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports